import React, {useEffect, useState} from 'react';
import {Form, Modal} from 'react-bootstrap';
import {useForm} from 'react-hook-form';
import {truckBillingService} from '../../services/truckBillingService';

interface CheckPaymentModalProps {
    show: boolean;
    toggle: () => void;
    jobId: number | null;
    defaultAmount: number | null;
    defaultDepositSlip: string;
    onDepositSlipSaved: (val: string) => void;
    refreshData: () => void;
}

const CheckPaymentModal: React.FC<CheckPaymentModalProps> = ({
                                                                 show,
                                                                 toggle,
                                                                 jobId,
                                                                 defaultAmount,
                                                                 defaultDepositSlip,
                                                                 onDepositSlipSaved,
                                                                 refreshData,
                                                             }) => {
    const {register, reset, handleSubmit} = useForm();
    const [isSaving, setIsSaving] = useState(false);

    useEffect(() => {
        if (show) {
            reset({
                checkNumber: '',
                depositSlipNumber: defaultDepositSlip,
                paymentAmount: defaultAmount ?? '',
            });
        }
    }, [show, defaultAmount, defaultDepositSlip, reset]);

    const onSave = (data: any) => {
        if (!jobId || isSaving) return;
        setIsSaving(true);

        const today = new Date().toISOString().split('T')[0];

        truckBillingService.postCheckPayment(jobId, {
            checkNumber: data.checkNumber,
            depositSlipNumber: data.depositSlipNumber,
            depositSlipDate: today,
            paymentAmount: parseFloat(data.paymentAmount),
        }).then(() => {
            onDepositSlipSaved(data.depositSlipNumber ?? '');
            toggle();
            refreshData();
        }).finally(() => setIsSaving(false));
    };

    return (
        <Modal show={show} onHide={toggle} className="fade" data-bs-backdrop="static">
            <Modal.Header>
                <h5 className="modal-title">Check Payment</h5>
                <button
                    type="button"
                    className="btn-close"
                    onClick={toggle}
                    aria-label="Close"
                />
            </Modal.Header>

            <Modal.Body>
                <Form>
                    <div className="row g-3">
                        <div className="col-6">
                            <label className="form-label">Deposit Slip #</label>
                            <input
                                {...register('depositSlipNumber')}
                                type="text"
                                className="form-control"
                                maxLength={25}
                                placeholder="Deposit slip"
                            />
                        </div>

                        <div className="col-6">
                            <label className="form-label">Amount</label>
                            <div className="input-group">
                                <span className="input-group-text">$</span>
                                <input
                                    {...register('paymentAmount')}
                                    type="number"
                                    step="0.01"
                                    className="form-control"
                                    placeholder="0.00"
                                />
                            </div>
                        </div>
                    </div>
                </Form>
            </Modal.Body>

            <Modal.Footer>
                <button
                    onClick={handleSubmit(onSave)}
                    type="button"
                    disabled={isSaving}
                    className="btn btn-primary text-uppercase"
                >
                    Save
                </button>

                <button
                    onClick={toggle}
                    type="button"
                    className="btn btn-secondary text-uppercase"
                >
                    Cancel
                </button>
            </Modal.Footer>
        </Modal>
    );
};

export default CheckPaymentModal;